import axios from 'axios';
import endpointUrls from 'global/Constants/endpointUrls';

export interface IMapIrSearchResult {
  value: string;
  address: string;
  city: string;
  county: string;
  district: string;
  geom: { type: string; coordinates: [number, number] };
  category: string;
  neighbourhood: string;
  region: string;
  type: string;
  text: string;
}

export const mapIrGetAddressFromLatLng = async (lat: number, lng: number) => {
  return await axios
    .get(endpointUrls.MapIrGetAddressFast(lat, lng), { headers: { 'x-api-key': mapIrToken() } })
    .then((res: any) => {
      return res.data;
    })
    .catch(() => {});
};

export const mapIrSearchAddress = async (text: string): Promise<IMapIrSearchResult[]> => {
  if (!text || text.trim().length < 2) return [];
  return await axios
    .get(endpointUrls.MapIrSearchAutocomplete(text), { headers: { 'x-api-key': mapIrToken() } })
    .then((res: any) => {
      return res.data?.value || [];
    })
    .catch(() => []);
};

export const mapIrToken = (): string => {
  const env = process.env.REACT_APP_NOD_ENV;

  switch (env as any) {
    case 'local':
      return process.env.REACT_APP_LOCAL_MAP_IR_TOKEN || '';
    case 'development':
      return process.env.REACT_APP_DEVELOPMENT_MAP_IR_TOKEN || '';
    case 'staging':
      return process.env.REACT_APP_STAGING_MAP_IR_TOKEN || '';
    case 'production':
      return process.env.REACT_APP_PRODUCTION_MAP_IR_TOKEN || '';
    default:
      return '';
  }
};
